
const CONFIG = {
    BOOKING_LENGTH_MINS: 15,    // booking length in minutes
    BOOKING_MIN_HOURS: 9,       // earliest booking time (0900)
    BOOKING_MAX_HOURS: 17,      // latest booking time (1700)
    WEB_TAB_TITLE_SUFFIX: "CREATE",
};

export default CONFIG;
